import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  addSection: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    cursor: 'pointer'
  },
  redColor: {
    color: theme.palette.primary.main
  }
}))

export default useStyles
